import { Badge } from '../../../components/ui';
import type { ReportIntegrity } from '../../../api/types';

const plural = (n: number, w: string) => `${n} ${w}${n === 1 ? '' : 's'}`;

/** Neutral evidence chips for one attempt. These are signals for the teacher, not verdicts. */
export default function IntegrityChips({ integrity }: { integrity?: ReportIntegrity | null }) {
  if (!integrity) return null;
  const { leaves, away_s, multi_window, over_time } = integrity;
  if (!(leaves > 0) && !multi_window && !over_time) return null;
  const mins = Math.max(away_s > 0 ? 1 : 0, Math.round(away_s / 60));
  return (
    <>
      {leaves > 0 && (
        <span title={`Left the exam screen ${plural(leaves, 'time')}, ${mins} min away in total`}>
          <Badge tone="neutral" size="sm">{`Left app ×${leaves}`}</Badge>
        </span>
      )}
      {multi_window && (
        <span title="The exam was open in split-screen or a floating window"><Badge tone="neutral" size="sm">Split screen</Badge></span>
      )}
      {over_time && (
        <span title="Submitted after the time limit (accepted, not changed)"><Badge tone="neutral" size="sm">Over time</Badge></span>
      )}
    </>
  );
}
